import type { ReactElement } from 'react';

/**
 * 교육 랜딩 슬라이드의 공통 부품 — 서비스 안내·교육 프로세스가 같이 쓴다.
 *
 * 넓은 화면에서 한 장이 화면 하나를 채운다 — 스크롤 한 번에 한 장씩 넘어간다.
 * `u-slide` 가 멈춤 지점이다(global.css · lib/use-slide-snap).
 */
export const SLIDE_FRAME =
  'u-slide relative isolate overflow-hidden lg:flex lg:min-h-[calc(100svh-4rem)] lg:items-center';

/** 슬라이드 뒤에 흐리게 깔리는 큰 번호 — 지금 몇 번째 장인지 한눈에 알린다 */
export function SlideNumber({ children }: { children: string }): ReactElement {
  return (
    <span
      aria-hidden="true"
      className="-right-[2%] -bottom-[6%] pointer-events-none absolute -z-10 select-none font-extralight font-mono text-[clamp(9rem,6rem+14vw,22rem)] leading-none tracking-[-0.08em] text-foreground/[0.045]"
    >
      {children}
    </span>
  );
}

/** 슬라이드 머리 라벨 — 모노 대문자 + 로고 각도의 짧은 막대 */
export function SlideEyebrow({ children }: { children: string }): ReactElement {
  return (
    <span className="inline-flex items-center gap-2.5 font-mono text-[12px] font-medium uppercase tracking-[0.16em] text-muted-foreground">
      <span aria-hidden="true" className="h-2.5 w-5 bg-primary [transform:skewX(var(--slant))]" />
      {children}
    </span>
  );
}
